import { render } from "./LocationSettings.vue?vue&type=template&id=2a6193c9&scoped=true"
import script from "./LocationSettings.vue?vue&type=script&lang=js"
export * from "./LocationSettings.vue?vue&type=script&lang=js"

import "./LocationSettings.vue?vue&type=style&index=0&id=2a6193c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6193c9"]])

export default __exports__